module.exports = __webpack_public_path__ + "cdc1ecdc6f23c63b173352cb1b55acc4.svg";